import { type Stage3EmailState, useCampaignBuilder } from "@/context/CampaignBuilderContext";
import { CompanyLogoSection } from "./CompanyLogoSection";
import { HeroBannerSection } from "./HeroBannerSection";

interface BrandingPanelProps {
  state: Stage3EmailState;
  onChange: (v: Partial<Stage3EmailState>) => void;
}

export default function BrandingPanel({ state, onChange }: BrandingPanelProps) {
  const { openCropDialog, campaignId } = useCampaignBuilder();

  return (
    <div className="px-5">
      <CompanyLogoSection
        enabled={state.logoEnabled}
        logoUrl={state.logoUrl}
        logoPadding={state.logoPadding}
        campaignId={campaignId}
        mediaType="logo"
        onChange={onChange}
        onCrop={() => openCropDialog("logo")}
      />

      <div style={{ borderTop: "1px solid var(--color-card-border)" }}>
        <HeroBannerSection
          enabled={state.bannerEnabled}
          bannerUrl={state.bannerUrl}
          campaignId={campaignId}
          mediaType="banner"
          onChange={onChange}
          onCrop={() => openCropDialog("banner")}
        />
      </div>

      {/* CTA Color */}
      <div className="py-4" style={{ borderTop: "1px solid var(--color-card-border)" }}>
        <span
          className="font-lato text-[13px] font-bold text-rodeo-black uppercase block mb-3"
          style={{ letterSpacing: "0.5px" }}
        >
          Button Color
        </span>
        <div className="flex items-center gap-3 mb-2">
          <input
            id="cta-color-input"
            type="color"
            value={state.ctaColor}
            onChange={(e) => onChange({ ctaColor: e.target.value })}
            className="gfg-color-input appearance-none w-11 h-11 border-2 border-smoke rounded-lg p-0.5 cursor-pointer bg-transparent transition-colors hover:border-dark-dust focus:border-rodeo-black focus:outline-none"
          />
          <span
            className="font-lato text-[13px] text-graphite uppercase"
            style={{ letterSpacing: "0.5px" }}
          >
            {state.ctaColor}
          </span>
        </div>
        <p className="font-lato text-[12px] text-graphite">Applied to CTA button in the email.</p>
      </div>
    </div>
  );
}
